import { customElement } from "lit/decorators.js";
import { Paragraph } from "@/components/paragraph";

@customElement("eko-card-description")
export class CardDescription extends Paragraph {
  constructor() {
    super();
    this.size = "md";
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-card-description": CardDescription;
  }
}

export default CardDescription;
